import { jsxs as p, jsx as a } from "react/jsx-runtime";
import R, { forwardRef as le, useState as b, useRef as T, useEffect as ne } from "react";
import { CreateChoiceList as ue } from "../CreateChoiceList/CreateChoiceList.js";
import { classes as w } from "../../utils/helpers.js";
import { s as v, C as de, A as _e } from "../../Form.module-DbpB9u1l.mjs";
import { X as fe } from "../../x-D8_C2o-U.mjs";
import { P as E } from "../../index-CZzwT3Oj.mjs";
import { T as he } from "../../triangle-D0AHL9lB.mjs";
import '../../assets/CustomDataList.css';function I() {
  return I = Object.assign || function(c) {
    for (var l = 1; l < arguments.length; l++) {
      var d = arguments[l];
      for (var o in d)
        Object.prototype.hasOwnProperty.call(d, o) && (c[o] = d[o]);
    }
    return c;
  }, I.apply(this, arguments);
}
function me(c, l) {
  if (c == null) return {};
  var d = pe(c, l), o, _;
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(c);
    for (_ = 0; _ < n.length; _++)
      o = n[_], !(l.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(c, o) && (d[o] = c[o]);
  }
  return d;
}
function pe(c, l) {
  if (c == null) return {};
  var d = {}, o = Object.keys(c), _, n;
  for (n = 0; n < o.length; n++)
    _ = o[n], !(l.indexOf(_) >= 0) && (d[_] = c[_]);
  return d;
}
var z = le(function(c, l) {
  var d = c.color, o = d === void 0 ? "currentColor" : d, _ = c.size, n = _ === void 0 ? 24 : _, x = me(c, ["color", "size"]);
  return /* @__PURE__ */ R.createElement("svg", I({
    ref: l,
    xmlns: "http://www.w3.org/2000/svg",
    width: n,
    height: n,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, x), /* @__PURE__ */ R.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /* @__PURE__ */ R.createElement("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }));
});
z.propTypes = {
  color: E.string,
  size: E.oneOfType([E.string, E.number])
};
z.displayName = "Search";
const u = {
  "custom-data-list": "_custom-data-list_6b9v2_1",
  "custom-data-list__select": "_custom-data-list__select_6b9v2_9",
  "custom-data-list__selection": "_custom-data-list__selection_6b9v2_17",
  "custom-data-list__selections": "_custom-data-list__selections_6b9v2_18",
  "custom-data-list__selected": "_custom-data-list__selected_6b9v2_38",
  "custom-data-list__remove": "_custom-data-list__remove_6b9v2_49",
  "custom-data-list__choices-wrapper": "_custom-data-list__choices-wrapper_6b9v2_67",
  "custom-data-list__choices": "_custom-data-list__choices_6b9v2_67",
  "custom-data-list__choices-wrapper--hidden": "_custom-data-list__choices-wrapper--hidden_6b9v2_114",
  "custom-data-list__icon": "_custom-data-list__icon_6b9v2_119",
  "custom-data-list__filter-wrap": "_custom-data-list__filter-wrap_6b9v2_133",
  "custom-data-list__filter": "_custom-data-list__filter_6b9v2_133",
  "custom-data-list__filter-icon": "_custom-data-list__filter-icon_6b9v2_150",
  "custom-data-list__select--touched": "_custom-data-list__select--touched_6b9v2_174"
};
function Se({
  name: c,
  options: l,
  label: d = "",
  placeholder: o = "",
  width: _ = 100,
  multiple: n = !1,
  showValidation: x = !0,
  ...Q
}) {
  var X, G, J;
  const [Y, Z] = b(`${v["form-field__input"]}`), M = T(), y = T(), L = T(), [V, W] = b(""), [F, ee] = b("clean"), [O, q] = b([]), [C, k] = b([]), [$, K] = b([]), [A, te] = b(null), [N, H] = b("hidden"), f = T(-1), se = `input-width--${_}`, ie = ["Enter", "Escape", "ArrowDown", "ArrowUp"], U = (e) => {
    let i = [];
    const t = (s) => {
      for (const r of s)
        r.status !== "filtered" && i.push(r), r.subcategories.length && t(r.subcategories);
    };
    return t(e), i;
  }, j = (e, i, t = "selected") => {
    if (!n && t === "selected" || t === "highlighted") {
      for (const s of e)
        if (s.status === t) {
          s.status = "active";
          break;
        }
    }
    for (const s of e) {
      if (s.id === i && (n && s.status !== "selected" && t === "selected" && q([...O, s]), s.status !== "selected" && (s.status = t), t === "selected")) {
        te(s);
        break;
      }
      s.subcategories.length && j(s.subcategories, i, t);
    }
    return e;
  }, B = (e) => {
    let i = [];
    const t = (s) => (s.parent_id ? (i.unshift(s.label), t(l.find((r) => r.id === s.parent_id))) : i.unshift(s.label), i);
    return t(e).join(":");
  }, ce = () => {
    setTimeout(() => {
      y.current.checkValidity() ? W("") : W(y.current.validationMessage);
    }, 100);
  }, S = (e) => {
    e == null || e.stopPropagation(), ee("touched"), Z(`${v["form-field__input"]} ${v["input--touched"]}`), N === "hidden" ? (H("visible"), M.current.focus()) : (H("hidden"), ce());
  }, oe = (e) => {
    const t = O.filter((m) => m.id !== e);
    q([...t]);
    let s = C;
    const r = (m, h) => {
      for (const P of m) {
        if (P.id === h) {
          P.status = "active";
          break;
        }
        P.subcategories.length && r(P.subcategories, h);
      }
      return m;
    }, g = r(s, e);
    k([...g]), document.querySelector(`select[name="${c}"] > option[value="${e}"]`).selected = !1;
  }, re = (e) => {
    if (e.stopPropagation(), e.keyCode === 40 || e.keyCode === 38)
      D(e);
    else {
      f.current = -1;
      const i = e.currentTarget.value, t = C, s = (m) => {
        for (const h of m)
          !h.label.toLowerCase().includes(i.toLowerCase()) && h.status !== "selected" && (h.status = "filtered"), h.subcategories.length && s(h.subcategories);
        return m;
      }, r = (m) => {
        for (const h of m)
          h.status === "filtered" && (h.status = "active"), h.subcategories.length && r(h.subcategories);
        return m;
      }, g = i === "" ? r(t) : s(t);
      k([...g]), K([...U(g)]);
    }
  }, ae = (e) => {
    const i = structuredClone(C), t = j(i, e);
    k([...t]), S(null), document.querySelector(`select[name="${c}"] > option[value="${e}"]`).selected = !0;
  }, D = (e) => {
    e.stopPropagation(), e.preventDefault();
    const i = e.key, t = C, s = (r) => {
      const g = $[r].id, m = j(t, g, "highlighted");
      k([...m]);
    };
    if (i === "ArrowDown" && N === "visible")
      f.current < $.length - 1 ? (s(f.current + 1), f.current++) : (s(0), f.current = 0);
    else if (i === "ArrowUp" && N === "visible")
      f.current > 0 ? (s(f.current - 1), f.current--) : (s($.length - 1), f.current = $.length - 1);
    else if (i === "Enter")
      if (N === "visible" && f !== -1) {
        const r = $[f.current].id, g = j(t, r);
        k([...g]), S(), document.querySelector(`select[name="${c}"] > option[value="${r}"]`).selected = !0;
      } else
        S();
    else if (i === "Escape" && N === "visible")
      S(), f.current = -1;
    else
      return !1;
    30 * f.current > 160 ? L.current.scrollTo(0, 30 * f.current) : L.current.scrollTo(0, 0);
  };
  return ne(() => {
    let e = l.map((t) => ({
      ...t,
      subcategories: [],
      status: "active"
    }));
    for (const t of e)
      if (Number.parseInt(t.parent_id, 10)) {
        let s = e.find((r) => r.id === t.parent_id);
        s && s.subcategories.push(t);
      }
    const i = e.filter((t) => t.parent_id === null);
    K(U(i)), k(i);
  }, [l]), /* @__PURE__ */ p("label", { htmlFor: c, className: w([v["form-field"], v[se]]), children: [
    x && /* @__PURE__ */ p(
      "i",
      {
        className: w([
          v["form-field__icon"],
          (X = y.current) != null && X.validity.valid ? "" : v["form-field__icon--invalid"]
        ]),
        style: d === "" ? { top: "0.4em" } : {},
        children: [
          ((G = y.current) == null ? void 0 : G.checkValidity()) && F === "touched" && /* @__PURE__ */ a(de, {}),
          !((J = y.current) != null && J.checkValidity()) && F === "touched" && /* @__PURE__ */ a(_e, {})
        ]
      }
    ),
    /* @__PURE__ */ a("span", { className: v["form-field__label"], children: d }),
    /* @__PURE__ */ p(
      "select",
      {
        name: c,
        className: w([
          u["custom-data-list__select"],
          F === "touched" ? u["custom-data-list__select--touched"] : ""
        ]),
        multiple: n,
        ref: y,
        ...Q,
        children: [
          /* @__PURE__ */ a("option", { value: "" }),
          l.length && l.map((e) => /* @__PURE__ */ a("option", { value: e.id, selected: e.selected, children: e.label }, `option-${e.id}`))
        ]
      }
    ),
    /* @__PURE__ */ p("div", { className: w([Y, u["custom-data-list"], "custom-data-list"]), children: [
      n && /* @__PURE__ */ p("ul", { className: `${u["custom-data-list__selections"]}`, onClick: S, children: [
        O.length !== 0 && O.map((e) => /* @__PURE__ */ p("li", { className: u["custom-data-list__selected"], children: [
          B(e),
          /* @__PURE__ */ a(
            "button",
            {
              title: "remove",
              type: "button",
              className: u["custom-data-list__remove"],
              onClick: (i) => {
                i.stopPropagation(), oe(e.id);
              },
              children: /* @__PURE__ */ a(fe, { width: 16, height: 16 })
            }
          )
        ] }, `selection-${e.id}`)),
        O.length === 0 && o !== "" && /* @__PURE__ */ a("span", { className: w([u["custom-data-list__placeholder"], "custom-data-list__placeholder"]), children: o })
      ] }),
      !n && /* @__PURE__ */ p("div", { className: u["custom-data-list__selection"], onClick: S, children: [
        A && B(A),
        !A && o !== "" && /* @__PURE__ */ a("span", { className: w([u["custom-data-list__placeholder"], "custom-data-list__placeholder"]), children: o })
      ] }),
      /* @__PURE__ */ p("div", { className: w([
        u["custom-data-list__choices-wrapper"],
        N === "visible" ? "" : u["custom-data-list__choices-wrapper--hidden"]
      ]), children: [
        /* @__PURE__ */ p("div", { className: u["custom-data-list__filter-wrap"], children: [
          /* @__PURE__ */ a(
            "input",
            {
              type: "text",
              ref: M,
              onChange: re,
              onKeyDown: (e) => {
                if (ie.includes(e.key))
                  D(e);
                else
                  return !0;
              },
              className: u["custom-data-list__filter"]
            }
          ),
          /* @__PURE__ */ a("i", { className: u["custom-data-list__filter-icon"], children: /* @__PURE__ */ a(z, { width: 14, height: 14 }) })
        ] }),
        /* @__PURE__ */ a("div", { className: u["custom-data-list__choices"], ref: L, onKeyDown: D, children: C.length !== 0 && /* @__PURE__ */ a(ue, { list: C, handleOnClick: ae }) })
      ] }),
      /* @__PURE__ */ a("i", { className: u["custom-data-list__icon"], children: /* @__PURE__ */ a(he, {}) })
    ] }),
    V !== "" && x && /* @__PURE__ */ a("div", { className: v["form-field__error-message"], children: V })
  ] });
}
export {
  Se as CustomDataList,
  Se as default
};
